import moment from 'moment'
import * as fmt from './fmt_utils'

export function round2Places(number) {
    return Math.round(number * 100) / 100
}

export function make2Places(number) {
    const rounded = round2Places(number)
    return rounded.toFixed(2)
}

// milliseconds
export const timeDifMilliseconds = (timeRecord) => {
    const startAt = timeRecord.startAt || Date.now()
    const endAt = timeRecord.endAt || Date.now()
    return moment(endAt).diff(startAt)
}

// milliseconds to hours
export const msToHrsRounded = (seconds) => {
    const hours = seconds / 1000 / 60 / 60
    return round2Places(hours).toFixed(2)
}

export function calcDuration(timeRecord, units='hours') {
    const startAt = timeRecord.startAt || Date.now()
    const endAt = timeRecord.endAt || Date.now()

    const dif = moment(endAt).diff(moment(startAt), units, true)
    return round2Places(dif)
}

export function stringToTimeString(timeString) {
    if (timeString.length == 0) {
        return ""
    }
    var ampm, hours, time
    time = parseTime(timeString)
    if (time.hours == null) {
        time = getNow()
    }
    ampm = time.hours > 11 && !time.am ? "pm" : "am"
    if (time.hours === 0) {
        hours = 12
    } else if (time.hours > 12) {
        hours = time.hours - 12
    } else {
        hours = time.hours
    }
    return "" + hours + ":" + (pad2(time.minutes)) + ampm
}

function isMilitary(timeString) {
    const length = timeString.length === 4
    const numsOnly = /^\d+$/.test(timeString)
    return length && numsOnly
}

export function parseTime(timeString) {
    var hours, fullTime, partialTime, minutes, am, pm
    if (timeString == null) {
        return {}
    }
    fullTime = timeString.match(/(\d+):(\d+)/)
    partialTime = timeString.match(/(\d+)/)
    if (fullTime) {
        hours = parseInt(fullTime[1], 10)
        minutes = parseInt(fullTime[2], 10)
    } else if (partialTime) {
        if (partialTime[1].length < 3) {
            hours = parseInt(partialTime[1], 10)
            minutes = 0
        } else if (partialTime[1].length === 3) {
            hours = parseInt(partialTime[1].substr(0, 1), 10)
            minutes = parseInt(partialTime[1].substr(1, 2), 10)
        } else if (partialTime[1].length === 4) {
            hours = parseInt(partialTime[1].substr(0, 2), 10)
            minutes = parseInt(partialTime[1].substr(2, 2), 10)
        }
    }
    if (isMilitary(timeString)) {
        if (hours > 24) {
            return {} // invalid
        }
        am = true
        pm = false
        if ((hours >= 12) && (hours !== 24)) {
            am = false
            pm = true
        }
        return {
            hours,
            minutes,
            am,
            pm,
        }
    }
    var timeLowerCase = timeString.toLowerCase()
    if (timeLowerCase.indexOf('a') > -1 || timeLowerCase.indexOf('p') > -1) {
        am = timeLowerCase.indexOf('a') > -1
        pm = timeLowerCase.indexOf('p') > -1
    } else {
        var now = getNow()
        am = now.hours < 12
        pm = now.hours >= 12
    }
    if (hours < 12 && pm === true) {
        hours += 12
    } else if (hours === 12 && pm === false) {
        hours = 0
    }
    if (hours > 24) {
        return {} // invalid
    }
    return {
        hours: hours,
        minutes: minutes,
        am: am,
        pm: pm,
    }
}

export function parseTimeStrOrDateTime(time) {
    const timeString = typeof time === 'string'
        ? time
        : fmt.shortTime(time)
    return parseTime(timeString)
}

export function getNow() {
    var now = new Date()
    var hours = now.getHours()
    return {
        hours: hours,
        minutes: now.getMinutes(),
        am: hours < 12,
        pm: hours >= 12,
    }
}

export function pad2(number) {
    return (number < 10 ? '0' : '') + number
}

export function mergeDateTimes(date, time) {
    if (!date || !time) return date || time || null

    const mDate = moment(date).startOf('day')
    const { hours, minutes } = parseTimeStrOrDateTime(time)

    return mDate.hours(hours).minutes(minutes).valueOf()
}

export function timeSince(startAt) {
    const dayDiff = moment.utc().diff(moment.utc(startAt), 'days')
    if (dayDiff > 0) {
        return dayDiff + " day" + (dayDiff > 1 ? "s" : "") + ", " + moment.utc(new Date().getTime() - startAt).format("H:mm:ss")
    }
    return moment.utc(new Date().getTime() - startAt).format("H:mm:ss")
}

export function over8hours(startAt) {
    return moment.utc().diff(moment.utc(startAt), 'hours') >= 8
}

export function isEndTimeBeforeStartTime(start, end) {
    const beginningTime = moment(moment(start).format('h:mma'), 'h:mma')
    const endTime = moment(end, 'h:mma')
    return endTime.isBefore(beginningTime)
}

export function isSameDay(endDate, startAt) {
    const endDateMs = new Date(fmt.numDateShort(endDate)).getTime()
    const startDateMs = new Date(fmt.numDateShort(startAt)).getTime()

    return endDateMs == startDateMs
}

export function advanceOneDay(date) {
    const oneDayInMs = 24 * 60 * 60 * 1000
    return date + oneDayInMs
}

export function confirmHighDuration(timeEntryMeta) {
    const duration = calcDuration(timeEntryMeta)

    if (duration > 10 && !confirm("This time entry is greater than 10 hours, is this correct?")) {
        return false
    }
    return true
}

export const getDaysUntilEnd = trialEndDate => {
    const today = new Date()
    const end = new Date(trialEndDate)
    const diffTime = end.getTime() - today.getTime()
    const days = diffTime / (1000 * 60 * 60 * 24)
    return days
}



// WEBPACK FOOTER //
// ./src/util/time_utils.js